import $ from 'jquery';
import run from '../../utilities/run';
import QuickBtnGroup from "../../components/QuickBtnGroup/QuickBtnGroup";
import { handleDisplayFor, setElementsFromScope } from "../../utilities/selectorHelpers";

const targetSelector = "#amazon-fba-search-pallet";


run(targetSelector, (mainEl) => {
  searchAmazonPallet(mainEl); 
});


function searchAmazonPallet(mainEl) {  

  const elsPage = {};
  
  const elementsPageMap = {    
    caseId: "#caseId1",
    palletId: "#palletId1",
    palletBtn: "#pallet",
    caseBtn: "#case",
    shippingTypeBtnGroupEl: ".shipping-type-toggler"
  }
    
  function init(){
    setElements();
    bindElements();
  }

  function bindElements(){    
    elsPage.palletBtn.on("click", function(){
      amazonPallet();
    });

    elsPage.caseBtn.on("click", function(){
      amazonCase();
    });    
  }

  function setElements(){
    setElementsFromScope(elsPage, elementsPageMap, mainEl);
    elsPage.caseId.hide();
    elsPage.palletId.show();
    quickButton();
  }

  function quickButton(){
    let shippingTypeBtnGroup = new QuickBtnGroup(elsPage.shippingTypeBtnGroupEl, {
      distributeWidth: true
    });
    shippingTypeBtnGroup.init();
  }

  function amazonCase() {
    elsPage.palletId.show();
    elsPage.caseId.hide();
    elsPage.palletId.val("");
    elsPage.palletBtn.removeClass('active');
    elsPage.caseBtn.addClass('active');
  }

  function amazonPallet(){
    elsPage.palletId.hide();
    elsPage.caseId.show();
    elsPage.caseId.val("");
    elsPage.caseBtn.removeClass('active');
    elsPage.palletBtn.addClass('active');
  }
  init();

}



// WEBPACK FOOTER //
// ./src/pages/amazon-fba-order/amazonFBAPalletSearch.js